import { Typography, useMediaQuery } from "@mui/material";
import {
  SimpleShowLayout,
  TextField,
  Labeled,
  DateField,
  useRecordContext,
  SelectField,
  FunctionField,
  ReferenceField,
} from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import EmployeeField from "server/components/Fields/EmployeeField";
import { GenderOptionsId, PersonIdTypes } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import ChangeDiplomaGradeModal from "./ChangeDiplomaGradeModal";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";

const BasicInfoSection = ({ getDetails }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();
  const isEmployee = !!record?.employeeId;
  return (
    <SimpleShowLayout sx={{ flex: 0, padding: 0 }}>
      <Grid
        container
        justifyContent="flex-end"
      >
        <Grid
          item
          xs={12}
          md={2}
          my={2}
        >
          <FunctionField
            render={record => (
              <div style={{ display: "flex", gap: 6, fontSize: "16px", fontWeight: "bold", paddingRight: "29rem" }}>
                <span>Статус:</span>
                <Typography
                  color={"primary"}
                  fontSize={16}
                  sx={{
                    fontWeight: "bold",
                    textAlign: "end",
                  }}
                >
                  {record.statusNameBg}
                </Typography>{" "}
              </div>
            )}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title={"Информация за кандидата"}
            paddingY={0}
          />
        </Grid>
        {isEmployee ? (
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Съществуващ служител на МУ София">
              <EmployeeField source="employeeId" />
            </Labeled>
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Име">
                <TextField source="user.firstName" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Презиме">
                <TextField source="user.secondName" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Фамилия">
                <TextField source="user.lastName" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Имейл">
                <TextField source="user.email" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Телефон">
                <TextField source="user.contactPhone" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Пол">
                <SelectField
                  source="user.gender"
                  choices={GenderOptionsId}
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Тип идентификатор">
                <SelectField
                  source="user.personIdType"
                  choices={PersonIdTypes}
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Идентификатор">
                <TextField source="user.personId" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <Labeled label="Дата на раждане">
                <DateField
                  source="user.birthDate"
                  locales="bg-BG"
                />
              </Labeled>
            </Grid>
          </>
        )}
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title={"Информация за дипломиране"}
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Университет">
            <TextField source="graduationInfo.university" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Квалификационна степен">
            <ReferenceField
              source="graduationInfo.degreeId"
              textAlign="center"
              reference={administrationRequests.getDegreesSelect()}
            >
              <TextField
                textAlign="center"
                source="name"
                label="Квалификационна степен"
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Специалност">
            <ReferenceField
              source="graduationInfo.specialityId"
              textAlign="center"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <TextField
                textAlign="center"
                source="name"
                label="Специалност"
              />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Дата на дипломиране">
            <DateField
              source="graduationInfo.diplomaDate"
              locales="bg-BG"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Номер на диплома">
            <TextField source="graduationInfo.diplomaNumber" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Рег. Номер на диплома">
            <TextField source="graduationInfo.diplomaRegistrationNumber" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Диплома серия">
            <TextField source="graduationInfo.diplomaSeries" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          gap={4}
          display="flex"
          alignItems="center"
        >
          <Labeled label="Оценка от Диплома">
            <TextField source="diplomaGrade" />
          </Labeled>
          <SecuredComponent permission={permissions.canManageSpecialistCampaignApplicationsGrade}>
            <ChangeDiplomaGradeModal getDetails={getDetails} />
          </SecuredComponent>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Удостоверение за признато висше образование">
            <TextField
              source="graduationInfo.higherEducationRecognitionCert"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <Labeled label="Удостоверение за признаване на професионална квалификация">
            <TextField
              source="graduationInfo.qualificationRecognitionCert"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default BasicInfoSection;
